import React from 'react';
import EmailSettingsForm from './EmailSettingsForm';

const EmailSettingsPage = () => {
  return (
    <div className="mx-auto max-w-7xl space-y-6">
      <div>
        <h1 className="text-2xl font-semibold leading-7">E-Mail Einstellungen</h1>
        <p className="text-muted-foreground">SMTP-Verbindungsdaten und Absender konfigurieren</p>
      </div>
      <EmailSettingsForm />
    </div>
  );
};

export default EmailSettingsPage;



